// package imports:
import React from "react";
// component imports:
import Entrypoint from "../Entrypoint";
import KnowYourCustomerPage from "../../components/DueDiligence/KnowYourCustomerPage";
import { DueDiligenceViewModel } from "../../types/DueDiligenceTypes";

const KnowYourCustomer: React.FC<DueDiligenceViewModel> = ({
    customers,
    individuals,
    warningMessage,
    employees,
    companyKYCPrice,
    individualKYCPrice
}) => {
    return (
        <Entrypoint>
            <KnowYourCustomerPage
                customers={customers ?? []}
                individuals={individuals ?? []}
                warningMessage={warningMessage ?? ""}
                employees={employees ?? []}
                companyKYCPrice={companyKYCPrice}
                individualKYCPrice={individualKYCPrice}
            />
        </Entrypoint>
    )
};

export default KnowYourCustomer;